export const colorPalette = {
    mainColor: '#E12F4F',
    White: '#FFFFFF',
    Dark: '#555555',
    Black: '#333333',
    MenuSelected: '#61FF71', 
    Shadow: '#000',
    Border: '#000',
  }